export const apiPath = {
  /*** Auth */
  LOGIN: '/api/master/login',
  LOGOUT_USER: '/api/master/auth/logout',
  REFRESH_TOKEN: '/api/master/auth/access-token',
  SET_RESET_PASSWORD: '/api/master/set-password/reset',
  FORGOT_PASSWORD: '/api/master/set-reset-password/reset',
  FORGOT_PASSWORD_INVITE: '/api/master/set-reset-password/invite',
  VERIFY_OTP: '/api/master/auth/verify-otp',

  /*** Patient */
  PATIENT: '/api/master/patient',
  PATIENT_CLINIC: '/api/master/patient-clinic',

  /*** Payment */
  PAYMENT: '/api/master/payment',

  /*** Clinic */
  CLINIC: '/api/master/clinic',
  /** Clinic locations — list + per-location sales-tax configuration. Locations
   *  themselves are still created/removed through PUT /clinic (full list). */
  LOCATION: '/api/master/location',

  /*** Roles & permissions */
  ROLE: '/api/master/role',
  PERMISSION: '/api/master/permission',
  ROLE_PERMISSION: '/api/master/role-permission',
  ME_PERMISSIONS: '/api/master/me/permissions',

  /*** Encounter */
  ENCOUNTER: '/api/master/encounters',

  /*** Tasks */
  TASK: '/api/master/tasks',

  /*** User */
  PROVIDER: '/api/master/provider',
  PROVIDER_PROFILE: '/api/master/provider/profile',

  /*** Specialty */
  SPECIALITY: 'api/master/speciality',

  /*** Intake / Consent Form Templates */
  INTAKE_FORM_CONSENT_TEMPLATE: '/api/master/intake-form-consent-template',
  FORM_TEMPLATE: '/api/master/intake-form-consent-template',

  /*** Vitals */
  VITALS: '/api/master/vitals',

  /*** Form Controller */
  FORM_CONTROLLER: '/api/master/form',
  /** Form-builder templates. Distinct from FORM_TEMPLATE above, which is the
   *  intake/consent template API despite the similar name. */
  FORM_BUILDER_TEMPLATES: '/api/master/form-templates',
  /** Filled-in instances of a form-builder template — one per template attached
   *  to an encounter (or patient/appointment). */
  FORM_SUBMISSIONS: '/api/master/form-submissions',
  /** Encounter note templates. Its /dropdown unions the legacy SOAP templates
   *  with form-builder VISIT_NOTE templates, tagging each row with `kind`. */
  VISIT_NOTE_TEMPLATE: '/api/master/visit-note-template',

  /*** Appointments */
  APPOINTMENTS: '/api/master/appointments',
  APPOINTMENT_TYPES: '/api/master/appointment-types',
  /** Per-user saved calendar filters/view — the `/me` routes act on the
   *  bearer-token user, there is never a user id in the URL. */
  CALENDAR_PREFERENCES: '/api/master/calendar-preferences',

  /*** Slots (provider availability lookup) */
  SLOTS: '/api/master/slots',

  /*** Lab orders (Fullscript-backed, custom UI) */
  LAB_ORDERS: '/api/master/lab-orders',
  LAB_ORDERS_OAUTH_AUTHORIZE: '/api/master/lab-orders/oauth/authorize',

  /*** Supplement orders (Fullscript-backed — shares OAuth/patient-sync with lab orders) */
  SUPPLEMENT_ORDERS: '/api/master/supplement-orders',

  /*** Twilio (communication module — SMS, voice, voicemail, IVR, transcripts). 
  NOTE the `v1` segment — the Twilio module sits behind a versioned prefix
  separate from the rest of the master service */
  TWILIO: '/api/master/v1/twilio',

  /*** Telehealth (Zoom Video SDK) — short-lived session JWT + join-link metadata */
  VIDEO: '/api/master/video',

  /*** DoseSpot e-Prescribing (Phase 1 — signed SSO links only) */
  DOSESPOT: '/api/master/dosespot',

  /*** Lookup catalog — master reference values (e.g. TASK_TITLE) */
  LOOKUPS: '/api/master/lookups',

  /*** Charge master */
  CHARGE_MASTER: '/api/master/charge-master',
  CHARGE_TYPE: '/api/master/charge-type',

  /*** Billing admin — promo/discount codes + tenant-wide military discount */
  PROMO_CODE: '/api/master/billing/promo-code',
  MILITARY_DISCOUNT_CONFIG: '/api/master/billing/military-discount-config',

  /*** Failed-payment recovery (dunning) — staff card update + reconcile */
  PAYMENT_RECOVERY: '/api/master/payment-recovery',

  /*** Patient AR ledger — double-entry charges (debits) + allocations (credits) */
  ACCOUNTS_RECEIVABLE: '/api/master/accounts-receivable',

  /*** Billing documents — receipt / invoice / statement PDFs off the AR ledger */
  BILLING_DOCUMENTS: '/api/master/billing',

  /*** Superbills — billable snapshots of signed+locked encounters */
  SUPERBILL: '/api/master/superbill',

  /*** Financial reports & KPI dashboard — read-only projections */
  FINANCIAL_REPORTS: '/api/master/financial-reports',

  /*** Plan of Care templates */
  PLAN_OF_CARE_TEMPLATES: '/api/master/plan-of-care/templates',

  /*** Patient Plan of Care (clinician-facing draft → sign → lifecycle) */
  PLAN_OF_CARE_PATIENT: '/api/master/plan-of-care/patient',

  /*** Plan of Care sections (master reference) */
  POC_SECTION: '/api/master/poc-section',

  /*** Commercial Plan (PA pricing object created from a signed provider PoC) */
  COMMERCIAL_PLAN: '/api/master/commercial-plan',

  /*** Purchase — one-off counter sale of Charge Master items, independent of
   *   PoC / commercial plan / subscription */
  PURCHASE: '/api/master/purchase',

  INVENTORY_ITEM: `/api/master/inventory-item`,

  DISPENSE_ITEM: `/api/master/dispense-record`,

  EXPIRING_SOON_INVENTORY: `/api/master/inventory-item/expiring-soon`,

  EXPIRED_INVENTORY: `/api/master/inventory-item/expired`,

  STOCK_IN: `/api/master/stock-in`,

  STOCK_OUT: `/api/master/stock-out`,

  ADJUST_INVENTORY: `/api/master/inventory-adjustment`,
  /*** Patient documents (client uploaded documents) */
  PATIENT_DOCUMENT: '/api/master/patient-document',

  SUBSCRIPTION_BYUUID: '/api/master/subscription/patient',

  /*** Subscription (base) — used for actions like POST /{uuid}/fra */
  SUBSCRIPTION: '/api/master/subscription',

  /*** Procedure rooms — shared bookable rooms, clinic + location scoped */
  PROCEDURE_ROOMS: '/api/master/procedure-rooms',

  /*** Sticky notes — short pinned notes on a patient (chart header quick notes) */
  STICKY_NOTES: '/api/master/sticky-notes',

  /*** Patient allergies — owned by the patient (not the patient-clinic enrolment) */
  PATIENT_ALLERGY: '/api/master/patient-allergy',
  /*** Allergy catalog — shared master list the patient-allergy picker draws from */
  ALLERGY: '/api/master/allergy',
}
